import React from 'react';
import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../../common/headers';
import useGeneralStore from '../../../../../store/general';
import './ModalAddElementsDict.scss'
import { ButtonBasic, TextareaDynamicPlaceholder, Checkbox, ButtonClose } from '@lk-gtcom/ecomlab-components';
import { TextPage } from '../../../../../components/TextPage/TextPage';
import { ModalComponent } from '../../../../../components/Modal/ModalComponent/ModalComponent';

interface ModalAddElementsDictProps {
    list?: any,
    setList?: (e: any) => void
    setIsModal: (e: boolean) => void
}

const ModalAddElementsDict = ({
    setIsModal,
    list = [],
    setList = () => { }
}: ModalAddElementsDictProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const [listPoints, setListPoints] = useState(list || []);
    const [checkedValues, setCheckedValues] = useState([]);
    const [textareaValue, setTextareaValue] = useState('');
    const [existingValues, setExistingValues] = useState([]);
    const [showGenModal, setShowGenModal] = useState(false);
    const [copiedFields, setCopiedFields] = useState([]);

    useEffect(() => {
        setList(listPoints)
    }, [listPoints]);

    const handleCheckboxChange = (fieldId) => {
        setCopiedFields((prev) =>
            prev.includes(fieldId)
                ? prev.filter((id) => id !== fieldId)
                : [...prev, fieldId]
        );
    };

    const handleAddPoints = () => {
        if (!textareaValue.trim()) return;

        const newItems = textareaValue
            .split('\n')
            .filter((line) => line.trim() && !existingValues.includes(line.trim()));

        setListPoints((prev) => [...prev, ...newItems]);
        setTextareaValue('');
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            handleAddPoints();
        }
    };

    const handleDeleteCheckedAttr = () => {
        setListPoints((prevPoints) =>
            prevPoints.filter((_, index) => !checkedValues.includes(index))
        );
        setCheckedValues([]);
    };

    return (
        <ModalComponent
            title='Добавить элементы списка'
            style={{
                maxWidth: '1100px',
                minHeight: '700px',
                maxHeight: '700px',
                height: 'auto'
            }}
            onClose={() => setIsModal(false)}
            child={
                <div className='modal-add-elements-dict-v2'>
                    <div className='modal-add-elements-dict-v2__content'>
                        <TextareaDynamicPlaceholder
                            changeValue={textareaValue}
                            width={'100%'}
                            placeholder="Введите значения списка через Enter"
                            onChange={setTextareaValue}
                            onKeyDown={handleKeyDown}
                        />

                        <div className='modal-add-elements-dict-v2__btn-group'>
                            <ButtonBasic
                                lilac
                                width='auto'
                                onClick={handleAddPoints}
                                text="Добавить"
                            />

                            <ButtonBasic
                                red
                                width='auto'
                                disabled={!checkedValues?.length}
                                text="Удалить"
                                onClick={handleDeleteCheckedAttr}
                            />
                        </div>

                        <div className="modal-add-elements-dict-v2__checkbox-group">
                            {listPoints.map((item: {}, idx: string) => (
                                <label className="modal-add-elements-dict__label" key={idx}>
                                    <Checkbox
                                        value={checkedValues.includes(idx)}
                                        onChange={() =>
                                            setCheckedValues((prev) =>
                                                prev.includes(idx)
                                                    ? prev.filter((i) => i !== idx)
                                                    : [...prev, idx]
                                            )
                                        }
                                    />
                                    <TextPage
                                        text={item?.label || item}
                                    />

                                    {showGenModal && (
                                        <Checkbox
                                            value={copiedFields.includes(item)}
                                            onChange={() => handleCheckboxChange(item)}
                                        >
                                            <p style={{ fontSize: '10px' }}>Copy ID</p>
                                        </Checkbox>
                                    )}
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className='modal-add-elements-dict-v2__btn-group-down'>
                        <ButtonBasic
                            green
                            onClick={() => setIsModal(false)}
                            size='56px'
                            text="Сохранить"
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalAddElementsDict }